import { isBusinessCategory, type CountryCode } from "../../data/types";
import { countryOf, validCrFor, validVatFor } from "../../domain/country";

/* Client-side validation for the company setup wizard (same rules as PUT /settings tenant and POST /auth/signup). */
export interface CompanyForm { nameEn: string; nameAr: string; cr: string; vat: string; city: string; size: string; category: string; country?: CountryCode }

export function validateCompany(f: CompanyForm, L: (en: string, ar: string) => string): Record<string, string> {
  const e: Record<string, string> = {};
  const c = countryOf(f.country);
  if (!f.nameEn.trim()) e.nameEn = L("Company name is required", "اسم المنشأة مطلوب");
  if (!f.nameAr.trim()) e.nameAr = L("Arabic name is required", "الاسم العربي مطلوب");
  const cr = f.cr.replace(/\s/g, "");
  const vat = f.vat.replace(/\s/g, "");
  if (c.code === "SA") {
    if (!cr) e.cr = L("CR number is required", "رقم السجل التجاري مطلوب");
    else if (!/^\d{10}$/.test(cr)) e.cr = L("CR number must be exactly 10 digits", "رقم السجل التجاري يجب أن يكون 10 أرقام");
    if (vat && !/^\d{15}$/.test(vat)) e.vat = L("VAT number must be 15 digits", "الرقم الضريبي يجب أن يكون 15 رقمًا");
  } else {
    if (!cr) e.cr = L(`${c.cr.label[0]} is required`, `${c.cr.label[1]} مطلوب`);
    else if (!validCrFor(cr, c.code)) e.cr = L(`Enter a valid ${c.cr.label[0].toLowerCase()}`, `أدخل ${c.cr.label[1]} بشكل صحيح`);
    if (!validVatFor(vat, c.code)) e.vat = c.vat.pattern ? L(`${c.vat.label[0]} must be ${c.vat.hint[0]}`, `${c.vat.label[1]} يجب أن يكون ${c.vat.hint[1]}`) : L(`There is no VAT in ${c.short[0]}; leave this empty`, `لا توجد ضريبة قيمة مضافة في ${c.short[1]}؛ اترك الحقل فارغًا`);
  }
  if (!isBusinessCategory(f.category)) e.category = L("Choose your business category", "اختر نشاط المنشأة");
  return e;
}

export function validPct(v: string): boolean {
  const n = Number(v);
  return v.trim() !== "" && Number.isFinite(n) && n >= 0 && n <= 100;
}
